<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      fill-rule="evenodd"
      d="M22 10.6v1.7s-1.3-.3-2-.3a6 6 0 0 0-5.8 7.5H4.5q-1 0-1.8-.7-.6-.6-.7-1.7v-6.5zm-15.7 2q-.6 0-1 .4-.4.3-.4.9v.8q0 .6.4 1 .4.3 1 .3h2.1q.6 0 1-.4.3-.3.4-.9V14q0-.6-.4-1-.4-.3-1-.3z"
      clip-rule="evenodd"
    />
    <path
      d="M19.5 4.5q1 0 1.8.7.6.6.7 1.7v1H2V7q0-1 .7-1.7.8-.7 1.8-.7zM19 21q0 1 1 1t1-1v-2h2q1 0 1-1t-1-1h-2v-2q0-1-1-1a1 1 0 0 0-1 1v2h-2a1 1 0 0 0-1 1q0 1 1 1h2z"
    />
  </svg>
</template>
